// utils/typedFetch.ts
import { ResultAsync, err, ok } from "neverthrow";

export const typedFetch = (
  url: string,
  options?: RequestInit,
): ResultAsync<Response, Error> =>
  ResultAsync.fromPromise(
    fetch(url, options),
    (e) => new Error(`Network error: ${String(e)}`),
  ).andThen((res) =>
    res.ok
      ? ok(res)
      : err(new Error(`HTTP error: ${res.status} ${res.statusText}`)),
  );
